import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history',
	routes: [
		// 초기 진입 페이지
		// { path: '/', redirect: '/login' },

		// 로그인 페이지
		// { path: '/login', name: 'login', component: () => import('@/views/login/LoginPage.vue'), meta: { title: '로그인 페이지' } },

		// 회원가입 페이지
		// { path: '/signup', name: 'signup', component: () => import('@/views/signup/SignupPage.vue'), meta: { title: '회원가입 페이지' } },

		// 아이디, 비밀번호 찾기 페이지
		// { path: '/findid', name: 'findid', component: () => import('@/views/find/FindId.vue'), meta: { title: '아이디 찾기 페이지' } },
		// { path: '/findidresult', name: 'findidresult', component: () => import('@/views/find/FindIdResult.vue'), meta: { title: '아이디 찾기 결과 페이지' } },
		// { path: '/findpw', name: 'findpw', component: () => import('@/views/find/FindPw.vue'), meta: { title: '비밀번호 찾기 페이지' } },
		// { path: '/findpwresult', name: 'findpwresult', component: () => import('@/views/find/FindPwResult.vue'), meta: { title: '비밀번호 찾기 결과 페이지' } },

		// 약관 페이지
		{ path: '/privacyconsent', name: 'privacyconsent', component: () => import('@/views/terms/PrivacyConsent.vue'), meta: { title: '개인정보수집 및 이용동의 페이지' } },
		{ path: '/termsconsent', name: 'termsconsent', component: () => import('@/views/terms/TermsConsent.vue'), meta: { title: '개인정보수집 및 이용동의 페이지' } },

		// 없는 페이지
		{ path: '*', component: () => import('@/components/common/NotFoundPage.vue'), meta: { title: 'Page is not found' } },
	],
});

export default router;
